<h3 mat-dialog-title>Create New Data View</h3>
<mat-dialog-content>
  <button (click)="newView('Job')" mat-flat-button>Job Based View</button>
  <button (click)="newView('Meeting')" mat-flat-button>Meeting Based View</button>
  <button (click)="newView('Visit')" mat-flat-button>Visit Based View</button>
  <button (click)="newView('Ticket')" mat-flat-button>Ticket Based View</button>

</mat-dialog-content>
<mat-dialog-actions>
  <button mat-dialog-close mat-flat-button>Close</button>
</mat-dialog-actions>
